<div class="widget-list-container">
    <div class="list">
        <div class="widget-container" *ngFor="let instance of instanceList">
            <tam-widget-list-item [instance]="instance" (onDelete)="onItemDeleted($event)" (refresh)="refreshItem($event)"></tam-widget-list-item>
        </div>
    </div>
    <div class="icon-add-bottom" tid="widget-add">
        <div class="icon-plus">
            <kendo-dropdownlist #dropdownlist [value]="addingWidget" (selectionChange)="onItemClick($event)" [popupSettings]="{appendTo: 'root'}" [data]="filteredWidgetList" [filterable]="true" [textField]="'name'" [valueField]="'id'" (filterChange)="handleFilter($event)">
            </kendo-dropdownlist>
        </div>
    </div>
</div>